import axios from "axios";

export const getAsyncRoutes = () => {
  return axios.get<any, any>("/get-async-routes");
};
